<template>
  <div class="account-setting">
    <div style="margin-top: 1rem">
      <van-icon name="arrow-left" @click="subtractMonth" />
      <span style="margin: 0 1rem">{{ year + "年" + month + "月" }}</span>
      <van-icon name="arrow" @click="plusMonth" />
    </div>
    <div style="margin-top: 1.5rem">
      <span style="font-size: 1.6rem; color: #1c86dc">{{
        JSON.stringify(source) != "{}" ? source.totalAmount / 100 : ""
      }}</span>
      <p style="margin: 0.5rem 0">当月出库金额(元)</p>
    </div>
    <div>
      <div class="shop1" @click="shopClick(0)">
        <div>
          <span class="shop_span">{{
            JSON.stringify(source) != "{}" ? source.childMerchantCount : ""
          }}</span>
          <p class="shop_p">直营合作伙伴</p>
        </div>
        <div>
          <span class="shop_span">{{
            JSON.stringify(source) != "{}"
              ? source.childMerchantAmount / 100
              : ""
          }}</span>
          <p class="shop_p">当月出库金额(元)</p>
        </div>
      </div>
      <div class="shop" @click="shopClick(1)">
        <div>
          <span class="shop_span">{{
            JSON.stringify(source) != "{}" ? source.proxyMerchantCount : ""
          }}</span>
          <p class="shop_p">省内合作伙伴</p>
        </div>
        <div>
          <span class="shop_span">{{
            JSON.stringify(source) != "{}"
              ? source.proxyMerchantAmount / 100
              : ""
          }}</span>
          <p class="shop_p">当月出库金额(元)</p>
        </div>
      </div>
    </div>
    <van-divider />
    <div><h3 style="text-align: initial; margin-left: 2rem">当月合作伙伴已出库统计</h3></div>
    <div class="Lists">
      <van-cell-group v-if="data.length > 0 ? true : false">
        <van-cell
          v-for="(item, index) in data"
          :key="index"
          :title="item.outStockMerchantFullName"
          :value="item.amount / 100 + '元'"
        />
      </van-cell-group>
      <div v-else>
        <van-empty description="当月未有出库明细" />
      </div>
    </div>
  </div>
</template>

<script>
import { report, list } from "@/api/exwarehouse";
// import { List } from 'vant';

export default {
  data() {
    return {
      show: false,
      source: {},
      data: [],
      year: "",
      month: "",
    };
  },
  mounted() {
    this.salesReport();
  },
  methods: {
    salesReport() {
      var time = new Date();
      this.year = time.getFullYear();
      this.month = time.getMonth() + 1;
      report(this.year, this.month)
        .then((res) => {
          this.source = res.result;
        })
        .catch((err) => {
          console.log(err);
        });
      this.Outboundetails(this.year, this.month);
    },
    // 进入门店详情
    shopClick(type) {
      if (type == 0) {
        // 下级门店
        this.$router.push({
          name: "subordinateShop",
          params: {
            active: type,
          },
        });
      } else {
        // 代管门店
        this.$router.push({
          name: "subordinateShop",
          params: {
            active: type,
          },
        });
      }
    },
    // 向前加一个月
    plusMonth() {
      const NewYear = new Date().getFullYear();
      const NewMonth = new Date().getMonth() + 1;
      // 当前设置月份 与 获取最新时间月份转成字符串 再判断
      if (this.year + "-" + this.month != NewYear + "-" + NewMonth) {
        this.month = this.month + 1;
        if (this.month == 13) {
          this.year = this.year + 1;
          this.month = 1;
        }
        report(this.year, this.month)
          .then((res) => {
            this.source = res.result;
          })
          .catch((err) => {
            console.log(err);
          });
        this.Outboundetails(this.year, this.month);
      } else {
        this.$toast("已是最新时间!");
      }
    },
    // 向后减一个月
    subtractMonth() {
      const minimumTime = "2015-1";
      if (this.year + "-" + this.month != minimumTime) {
        this.month = this.month - 1;
        if (this.month == 0) {
          this.year = this.year - 1;
          this.month = 12;
        }
        report(this.year, this.month)
          .then((res) => {
            this.source = res.result;
          })
          .catch((err) => {
            console.log(err);
          });
        this.Outboundetails(this.year, this.month);
      } else {
        this.$toast("已是最早时间!");
      }
    },
    Outboundetails(year, month) {
      // 下级门店出库明细
      this.data = [];
      var Lists = {};
      list(year, month)
        .then((res) => {
          // this.data = res.result.rows;
          // console.log(res.result.rows);
          res.result.rows.forEach((e) => {
            //新建属性名
            if (Object.keys(Lists).indexOf("" + e.outStockMerchantId) === -1) {
              Lists[e.outStockMerchantId] = [];
            }
            //对应插入属性值
            Lists[e.outStockMerchantId].push(e);
          });
          for (const i in Lists) {
            console.log(Lists[i], "aaa");
            if (Lists[i].length > 1) {
              var replace = {};
              replace.amount = 0;
              Lists[i].map((items) => {
                replace.amount += items.amount;
                replace.outStockMerchantFullName =
                  items.outStockMerchantFullName;
                replace.gmtCreate = items.gmtCreate;
              });
              this.data.push(replace);
            } else {
              this.data.push(Lists[i][0]);
            }
          }
          console.log(this.data);
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.account-setting {
  .shop1 {
    width: 75%;
    margin: 0 auto;
    display: flex;
    justify-content: space-around;
    padding: 0.8rem;
    background: #26baff;
    border-radius: 1rem;
    .shop_span {
      color: #fff;
      font-size: 1.4rem;
    }
    .shop_p {
      color: #fff;
      margin: 0.5rem 0;
    }
  }
  .shop {
    width: 75%;
    margin: 0 auto;
    display: flex;
    justify-content: space-around;
    padding: 0.8rem;
    background: #f3f3f3;
    border-radius: 1rem;
    .shop_span {
      color: #1c86dc;
      font-size: 1.4rem;
    }
    .shop_p {
      margin: 0.5rem 0;
    }
  }
  .Lists {
    width: 85%;
    margin: 0 auto;
    text-align: initial;
  }
}
</style>
